/* ============================================================
   look-slider.js — Shop the Look Slider (drawer propio)
   Abre un drawer desde la izquierda con TODOS los productos del look,
   variantes en lista compacta y add-to-cart vía /cart/add.js.
   ============================================================ */
(function () {
  'use strict';

  var OPEN_ATTR = '[data-look-open]';
  var SECTION = '[data-look-slider]';
  var drawer, overlay, contentHolder, lastFocus;

  function buildDrawer() {
    if (drawer) return;
    overlay = document.createElement('div');
    overlay.className = 'stl-drawer__overlay';

    drawer = document.createElement('div');
    drawer.className = 'stl-drawer';
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    drawer.setAttribute('aria-label', 'Shop the Look');
    drawer.innerHTML =
      '<div class="stl-drawer__panel">' +
      '<button type="button" class="stl-drawer__close" data-stl-close aria-label="Cerrar">&times;</button>' +
      '<div class="stl-drawer__scroll" data-stl-content></div>' +
      '</div>';

    document.body.appendChild(overlay);
    document.body.appendChild(drawer);
    contentHolder = drawer.querySelector('[data-stl-content]');

    overlay.addEventListener('click', close);
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-stl-close]')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });
  }

  function open(button) {
    var section = button.closest(SECTION);
    if (!section) return;
    var id = button.getAttribute('data-look-open');
    var tmpl = section.querySelector('template[data-look-template="' + id + '"]');
    if (!tmpl) return;

    buildDrawer();
    contentHolder.innerHTML = '';
    contentHolder.appendChild(tmpl.content.cloneNode(true));
    contentHolder.scrollTop = 0;

    lastFocus = document.activeElement;
    document.documentElement.classList.add('stl-drawer-open');
    requestAnimationFrame(function () {
      overlay.classList.add('is-open');
      drawer.classList.add('is-open');
    });

    initItems(contentHolder);
    var closeBtn = drawer.querySelector('.stl-drawer__close');
    if (closeBtn) closeBtn.focus();
  }

  function close() {
    if (!drawer) return;
    overlay.classList.remove('is-open');
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('stl-drawer-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* ---------- Selección de variante por producto ---------- */
  function initItems(root) {
    root.querySelectorAll('[data-stl-item]').forEach(function (item) {
      var variants = [];
      var script = item.querySelector('[data-stl-variants]');
      try { variants = JSON.parse(script.textContent); } catch (e) { variants = []; }

      var selects = Array.prototype.slice.call(item.querySelectorAll('[data-stl-select]'));
      var hasOptions = selects.length > 0;

      var selected = [];
      selects.forEach(function (sel) {
        selected[parseInt(sel.getAttribute('data-option-index'), 10)] = sel.value;
      });
      if (!hasOptions && variants.length) { selected = variants[0].options || []; }

      var addBtn = item.querySelector('[data-stl-add]');
      var priceEl = item.querySelector('[data-stl-price]');
      var label = item.querySelector('[data-stl-add-label]');
      var mediaImg = item.querySelector('[data-stl-media]');
      var defaultSrc = mediaImg ? mediaImg.getAttribute('src') : '';

      function currentVariant() {
        if (!variants.length) return null;
        if (!hasOptions) return variants[0];
        return variants.find(function (v) {
          return v.options.every(function (val, idx) { return val === selected[idx]; });
        }) || null;
      }

      // Deshabilita (gris) las opciones agotadas según lo ya seleccionado
      function updateAvailability() {
        selects.forEach(function (sel, sIdx) {
          Array.prototype.forEach.call(sel.options, function (optEl) {
            var oiThis = parseInt(sel.getAttribute('data-option-index'), 10);
            var avail = variants.some(function (v) {
              if (!v.available) return false;
              for (var i = 0; i < selects.length; i++) {
                var oi = parseInt(selects[i].getAttribute('data-option-index'), 10);
                if (oi === oiThis) {
                  if (v.options[oi] !== optEl.value) return false;
                } else if (selected[oi] != null && v.options[oi] !== selected[oi]) {
                  return false;
                }
              }
              return true;
            });
            optEl.disabled = !avail;
          });
        });
      }

      function updateImage(v) {
        if (!mediaImg) return;
        if (v && v.image) mediaImg.src = v.image;
        else if (defaultSrc) mediaImg.src = defaultSrc;
      }

      function update() {
        var v = currentVariant();
        updateImage(v);
        if (v) {
          addBtn.setAttribute('data-variant-id', v.id);
          if (priceEl && v.price) priceEl.textContent = v.price;
          if (v.available) {
            addBtn.disabled = false;
            addBtn.removeAttribute('aria-disabled');
            if (label) label.textContent = 'Agregar';
          } else {
            addBtn.disabled = true;
            addBtn.setAttribute('aria-disabled', 'true');
            if (label) label.textContent = 'Agotado';
          }
        } else {
          addBtn.disabled = true;
          addBtn.setAttribute('aria-disabled', 'true');
          if (label) label.textContent = 'Agotado';
        }
      }

      selects.forEach(function (sel) {
        sel.addEventListener('change', function () {
          selected[parseInt(sel.getAttribute('data-option-index'), 10)] = sel.value;
          updateAvailability();
          update();
        });
      });

      addBtn.addEventListener('click', function () {
        if (addBtn.disabled) return;
        var vid = addBtn.getAttribute('data-variant-id');
        if (vid) addToCart(vid, addBtn, label);
      });

      updateAvailability();
      update();
    });
  }

  /* ---------- Add to cart ---------- */
  function addToCart(variantId, btn, label) {
    var lbl = label || btn;
    var original = lbl.textContent;
    btn.classList.add('is-loading');
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      // Cart Sections API: pedimos el HTML de la sección del carrito en la MISMA
      // respuesta del add. Así el contenido del drawer refleja el carrito ya
      // actualizado de forma atómica y se evita el desfase del primer producto.
      body: JSON.stringify({
        items: [{ id: parseInt(variantId, 10), quantity: 1 }],
        sections: 'api-cart-items',
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        btn.classList.remove('is-loading');
        if (!res.ok) throw new Error((res.d && (res.d.description || res.d.message)) || 'Error');
        btn.classList.add('is-added');
        lbl.textContent = '✓ Agregado';
        var sectionHtml = res.d && res.d.sections && res.d.sections['api-cart-items'];
        refreshCart(sectionHtml);
        window.setTimeout(function () {
          btn.disabled = false;
          btn.classList.remove('is-added');
          lbl.textContent = original;
        }, 2200);
      })
      .catch(function (e) {
        btn.classList.remove('is-loading');
        btn.disabled = false;
        lbl.textContent = 'Reintentar';
        console.error('[look-slider] add to cart:', e);
        window.setTimeout(function () { lbl.textContent = original; }, 2200);
      });
  }

  /* ---------- Mapear el HTML de api-cart-items al cart drawer del theme ----------
     El cart drawer del theme vive dentro de <template data-cart-drawer-template>
     y se clona (vacío) al abrir el carrito por primera vez. Por eso inyectamos
     en AMBOS: el DOM vivo (si ya se clonó) y el template (para que el clon futuro
     traiga los items). Así el primer producto aparece siempre. */
  function mapInto(root, parsed) {
    if (!root) return;
    var itemsHolder = root.querySelector('[data-items-holder]');
    var priceHolder = root.querySelector('[data-cart-price-holder]');
    var pairHolder = root.querySelector('[data-pair-products-holder]');

    if (priceHolder && parsed.price) priceHolder.innerHTML = parsed.price.innerHTML;
    if (itemsHolder) itemsHolder.innerHTML = parsed.empty ? '' : parsed.lineItems.innerHTML;
    if (pairHolder) pairHolder.innerHTML = !parsed.empty && parsed.upsell ? parsed.upsell.innerHTML : '';

    root
      .querySelectorAll('.cart-drawer__items, [data-cart-notes-holder], [data-foot-holder]')
      .forEach(function (el) { el.classList.toggle('hidden', parsed.empty); });
    root
      .querySelectorAll('.cart-drawer__empty-message')
      .forEach(function (el) { el.classList.toggle('hidden', !parsed.empty); });

    // Contador del título ("X productos") + mostrarlo si hay items.
    root.querySelectorAll('[data-cart-items-qty]').forEach(function (el) {
      if (parsed.qtyLabel != null) el.innerHTML = parsed.qtyLabel;
      el.classList.toggle('hidden', parsed.empty);
    });
    // Form de checkout (botón de comprar): el theme lo oculta con .hidden
    // cuando el carrito está vacío. Lo mostramos cuando hay items.
    root.querySelectorAll('#cartDrawerCheckoutForm, [data-cart-form]').forEach(function (el) {
      el.classList.toggle('hidden', parsed.empty);
    });
  }

  function applyCartHtml(html) {
    var data = document.createElement('div');
    data.innerHTML = html || '';

    var countEl = data.querySelector('[data-api-item-count]');
    var count = countEl ? parseInt(countEl.getAttribute('data-api-item-count'), 10) : null;

    var parsed = {
      lineItems: data.querySelector('[data-api-line-items]'),
      upsell: data.querySelector('[data-api-upsell-items]'),
      price: data.querySelector('[data-api-cart-price]'),
      qtyLabel: countEl ? countEl.innerHTML : null
    };
    // "vacío" según el conteo real del carrito (más fiable que solo line-items)
    parsed.empty = count != null ? count <= 0 : !parsed.lineItems;

    // 1) DOM vivo (drawer ya clonado/abierto alguna vez)
    mapInto(document, parsed);
    // 2) Template del cart drawer (aún sin clonar): para el primer producto
    var tpl = document.querySelector('[data-cart-drawer-template]');
    if (tpl && tpl.content) mapInto(tpl.content, parsed);
  }

  /* ---------- Refrescar el cart drawer del theme (sin cerrar el drawer STL) ----------
     Usa el HTML atómico de la Cart Sections API si viene; si no, hace fetch. */
  function refreshCart(sectionHtml) {
    function done() {
      // Actualiza el contador del icono y notifica al theme
      document.dispatchEvent(new CustomEvent('bkp:cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('theme:cart:added', { bubbles: true }));
    }
    if (sectionHtml) {
      try { applyCartHtml(sectionHtml); } catch (e) {}
      done();
      return;
    }
    // Respaldo: fetch de la sección (por si no vino en la respuesta del add)
    var cartUrl = (window.theme && window.theme.routes && window.theme.routes.cart_url) || '/cart';
    fetch(cartUrl + '?section_id=api-cart-items', { cache: 'no-store' })
      .then(function (r) { return r.text(); })
      .then(function (html) { applyCartHtml(html); })
      .catch(function () {})
      .then(done);
  }

  document.addEventListener('click', function (e) {
    var button = e.target.closest && e.target.closest(OPEN_ATTR);
    if (!button) return;
    e.preventDefault();
    open(button);
  });
})();
